$(document).ready(function() {
  $(".artist-content").each(function() {
    var fullText = $(this).find("p").text().trim(); // Get full text and trim whitespace
    var words = fullText.split(" ");
    var wordLimit = window.matchMedia("(max-width: 767px)").matches ? 31 : 65; // 31 words for mobile, 50 for desktop

    if (words.length > wordLimit) {
      var visibleText = words.slice(0, wordLimit).join(" ");
      var hiddenText = words.slice(wordLimit).join(" ");

      // Set initial content to visible text with ellipsis
      $(this).find("p").html(visibleText + '...');

      // Create a hidden span for the extra content to slide down/up within the same paragraph
      var hiddenSpan = $('<span class="hidden-text" style="display:none;"> ' + hiddenText + '</span>');
      $(this).find("p").append(hiddenSpan); // Append the hidden text within the same <p> tag

      $(this).find(".toggle-btn").css("display", "block"); // Ensure the button is visible

      // Add click functionality to each button
      $(this).find(".toggle-btn").click(function() {
        var button = $(this);
        var hiddenContent = button.siblings().find('.hidden-text'); // Get the hidden content span

        if (hiddenContent.is(':hidden')) {
          // Expand (show full text smoothly)
          hiddenContent.slideDown(800);
          button.text("Show Less");
        } else {
          // Collapse (hide full text smoothly)
          hiddenContent.slideUp(800);
          button.text("Read More");
        }
      });
    }
  });
});
